type Permission = {
  id: string;
  name: string;
};

type PermissionsListType = {
  group: string;
  name: string;

  permissions: Permission[];
};

export const PERMISSIONS_LIST: PermissionsListType[] = [
  {
    group: 'Management Permissions',
    name: 'כל ההרשאות לניהול כל הרשת',
    permissions: [
      {id: 'open_account', name: 'פתיחת חשבון'},
      {id: 'manage_checklists', name: 'ניהול צ’קליסטים'},
      {id: 'manage_tasks', name: 'ניהול משימות'},
      {id: 'manage_alerts', name: 'ניהול תקלות'},
      {id: 'manage_users', name: 'ניהול משתמשים'},
      {id: 'manage_employees', name: 'ניהול עובדים'},
      {id: 'manage_equipment', name: 'ניהול ציוד'},
      {id: 'manage_suppliers', name: 'ניהול ספקים'},
      {id: 'manage_permissions', name: 'ניהול הרשאות'},
      {id: 'manage_tutorials', name: 'ניהול הדרכות'},
      {id: 'manage_reports', name: 'ניהול דוחות'},
      {id: 'manage_organization', name: 'ניהול ארגון'},
      {id: 'manage_dashboard', name: 'ניהול לוח מחוונים'},
      {id: 'manage_forms', name: 'ניהול טפסים'},
      {
        id: 'new_customer_theme_setup',
        name: 'יצירת ערכת נושא לקוח חדש (מאסטר אדמין)',
      },
      {
        id: 'application_assignment_for_customers',
        name: 'הקצאת יישומים ללקוחות (מאסטר אדמין)',
      },
    ],
  },
  {
    group: 'View Permissions',
    name: 'הרשאות צפייה',
    permissions: [
      {id: 'view_restaurant', name: 'צפייה במסעדה'},
      {id: 'view_regulation', name: 'צפייה ברגולציה'},
      {id: 'view_dashboard', name: 'צפייה בדשבורד'},
      {id: 'view_reports', name: 'צפייה בדוחות'},
      {id: 'view_tutorials', name: 'צפייה בהדרכות'},
    ],
  },
  {
    group: 'Regulatory Permissions',
    name: 'הרשאות רגולציה',
    permissions: [
      {id: 'manage_regulations', name: 'ניהול רגולציה'},
      {id: 'manage_regulation_certificates', name: 'ניהול תעודות'},
    ],
  },
  {
    group: 'Mobile App Permissions',
    name: 'הרשאות שימוש באפליקציה מובייל',
    permissions: [
      {id: 'all_permissions', name: 'כל ההרשאות'},
      {id: 'view_tasks', name: 'צפיה במשימות'},
      {id: 'view_tutorials_mobile', name: 'צפיה בהדרכות'},
      {id: 'comment', name: 'כתובת תגובות'},
      {id: 'report_by_app', name: 'דיווח באפליקציה'},
      {id: 'view_reports', name: 'צפייה בדוחות'},
      {id: 'customize_notifications', name: 'התראות - התאמה אישית'},
    ],
  },
];

export const MANAGEMENT_PERMISSION_IDS = PERMISSIONS_LIST.flatMap(group =>
  group.group === 'Mobile App Permissions'
    ? []
    : group.permissions.map(permission => permission.id),
);

export const WORKER_PERMISSION_IDS = [
  'view_restaurant',
  'view_regulation',
  'view_dashboard',
  'view_reports',
  'view_tutorials',
  'view_tasks',
  'view_tutorials_mobile',
  'comment',
  'report_by_app',
  'customize_notifications',
];

export const PERMISSIONS_LEVELS = [
  {
    id: 'senior_management',
    name: 'דרג ניהולי בכיר',
    desc: 'צפייה בהכל, הכנסת צקליסט ומשימות',
    permissions: MANAGEMENT_PERMISSION_IDS,
  },
  {
    id: 'management',
    name: 'דרג ניהולי',
    desc: 'כל ההרשאות, צפייה במסעדה, צפייה בהדרכות, ניהול הדרכות, ניהול צ’קליסטים, ניהול משימות, ניהול ציוד, ניהול תקלות, ניהול ספקים',
    permissions: MANAGEMENT_PERMISSION_IDS,
  },
  {
    id: 'work',
    name: 'דרג עבודה',
    desc: 'כתיבת תגובות, צפייה בהדרכות, דיווח באפליקציה, צפיה במשימות, צפייה בהדרכות, צפייה במסעדה',
    permissions: WORKER_PERMISSION_IDS,
  },
  {
    id: 'trainee',
    name: 'מתלמד',
    desc: 'צפייה בהדרכות, צפייה במסעדה',
    permissions: ['view_tutorials', 'view_restaurant'],
  },
  {
    id: 'general_ipad',
    name: 'כללי אייפד',
    desc: 'צפייה בהדרכות, צפייה במסעדה, מאופשר לאפליקציית מחשב בלבד ולא למכשיר הסלולרי.',
    permissions: ['view_tutorials', 'view_restaurant'],
  },
];
